import { useKeycloak } from "@react-keycloak/web";
import Http, { HttpHeader } from "../engine/Http";
import { useEffect, useState } from "react";

export type Customer = {
  id: number;
  name: string;
}

const useCustomerApi = () => {
  const { keycloak } = useKeycloak();
  const [ headers, setHeaders ] = useState<HttpHeader[]>();
  const [ ready, setReady ] = useState<boolean>(false);

  const fetchCustomers = (): Promise<Customer[]> => Http.get(`/api/customers`, headers === undefined ? [] : headers);

  const fetchCustomer = (customerId: number): Promise<Customer> => Http.get(`/api/customers/${customerId}`, headers === undefined ? [] : headers);

  useEffect(() => {
    setHeaders([{ name: 'Authorization', value: `Bearer ${keycloak.token }` }]);
    setReady(keycloak.authenticated);
  }, [ keycloak.authenticated, keycloak.token ]);

  return {
    fetchCustomers,
    fetchCustomer,
    ready
  };
};

export default useCustomerApi;